import { useEffect, useState } from 'react';
import { getTripOptionsStr } from '#/trip-planner/queries';
import otpUiConfig from '#/otp-ui-config';
import useCurrentQuery from '#/trip-planner/hooks/useCurrentQuery';

// Retrieve the URL that would be used to query for the trip planner
export default () => {
  const { currentQuery } = useCurrentQuery();
  const [currentQueryRequest, setCurrentQueryRequest] = useState(
    getTripOptionsStr(otpUiConfig, currentQuery)
  );

  useEffect(() => {
    setCurrentQueryRequest(getTripOptionsStr(otpUiConfig, currentQuery));
  }, [currentQuery]);

  return {
    currentQueryRequest,
  };
};
